module.exports = "data:image/gif;base64,R0lGODlhBAAHAIAAAGZmZv///yH5BAEAAAEALAAAAAAEAAcAAAIIRB6Wu2AKUQEAOw=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/arrow_00.gif
// module id = AMoc
// module chunks = 0